import { useMutation } from '@tanstack/react-query'

import { postCallbackFreeeAuthForAccounting } from '@src/api'
import { DefaultApiPostCallbackFreeeAuthForAccountingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePostCallbackFreeeAuthForAccounting = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiPostCallbackFreeeAuthForAccountingRequest) =>
      postCallbackFreeeAuthForAccounting(axiosInstance, params),
  })
}
